/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientPanel/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import ProfileActions from 'DesignSystem/ProfileActions/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PatientPanel({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/Content/Content/TaskOverview/Content/Actions/PatientPanel"
  
}) {
let taskPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'patient._id',
})
let taskPatientPersonValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'patient.person',
})
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<ProfileActions
  viewPath={`${viewPath}/ProfileActions`}
 gap={dtSpaceMs}
 data="task.patient._id"
 patient_id={taskPatientIdValueData}
 data="task.patient.person"
 person={taskPatientPersonValueData}
 data="task.patient"
/>
{children}
</React.Fragment>)
}